import { createStore, combineReducers } from 'redux';

import { FETCH_USER, SET_UPDATING } from './actionTypes';

const initialState = {
  isLoggedIn: false,
  isUpdating: false,
};

function isLoggedIn(state = initialState.isLoggedIn, action) {
  switch (action.type) {
    case FETCH_USER:
      return true;
    default:
      return state;
  }
}

function isUpdating(state = initialState.isUpdating, action) {
  switch (action.type) {
    case SET_UPDATING:
      return action.value;
    default:
      return state;
  }
}

const store = createStore(combineReducers({ isLoggedIn, isUpdating }), initialState);

export default store;
